/**
 * Motion values for JavaScript animation (Motion), mirroring the CSS tokens in
 * theme.css so a transition in code and one in a stylesheet feel the same.
 */
export const ease = {
  outExpo: [0.16, 1, 0.3, 1],
  inOutQuart: [0.76, 0, 0.24, 1],
} as const;

export const duration = {
  instant: 0.12,
  quick: 0.22,
  base: 0.42,
  slow: 0.7,
  scene: 1.1,
} as const;

/** Springs for things a finger moves or a value lands on. */
export const spring = {
  snappy: { type: "spring", stiffness: 520, damping: 38, mass: 0.8 },
  soft: { type: "spring", stiffness: 180, damping: 26 },
} as const;
